import NewsPost from '@/components/news-post/NewsPost.vue'
import vSelect from 'vue-select'
import { BPaginationNav, BPagination } from 'bootstrap-vue'
import '@/scripts/vue/dayjs'
import VueScrollTo from 'vue-scrollto'
import fetchItems from '@/scripts/vue/api-axios'
import ListStateMixin from '@/mixins/ListStateMixin'

const categoryId = typeof window.category_id === "undefined" ? 1 : window.category_id
const perPageInitial = typeof window.perPageInitial === "undefined" ? 3 : window.perPageInitial

const newsListConfig = {
  components: {
    NewsPost,
    vSelect,
    BPaginationNav,
    BPagination
  },
  mixins: [ListStateMixin('newsList')],
  mounted() {

    this.$Progress.start();
    fetchItems(`/yiifnews?categoryId=${ categoryId }`)
      .then((items) => {
        this.news = items;
      })
      .then(() => {
        fetchItems(`/yiifcategory/news`)
          .then((items) => {
            this.scrollTo('body', 0);

            this.categories = items;
            this.getSelectOptions();
            this.$Progress.finish();

            // category attribute from url
            const categoryParam = parseInt(window.utils.getQueryStringParameter('newsCategory'));
            if ( categoryParam )
            {
              const currentCategory = this.selectOptions.filter(option => {
                return option.id === categoryParam
              });

              this.selectedCategory = currentCategory[0];
            }

            // pagination attribute from url
            const pageParam = window.utils.getQueryStringParameter('newsPage');
            if ( pageParam )
            {
              this.currentPage = pageParam;
            }

          })
      });
  },
  data: () => ({
    news: [],
    categories: [],
    selectOptions: [],
    selectedCategory: null,
    currentPage: 1,
    perPage: perPageInitial,
    scrollerIsScrolling: false,
    categoryId: categoryId
  }),
  computed: {
    itemsForList() {
      return this.filteredItems.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage,
      );
    },
    rows() {
      return this.filteredItems.length
    },
    filteredItems() {
      return this.news.filter(item => {
        if (!this.selectedCategory || !this.selectedCategory.id) return true;
        const articleCategories = new Set(Object.keys(item.category));
        const selectedCategories = this.selectedCategory.categories;
        for(let index = 0; index < selectedCategories.length; index++) {
          if (articleCategories.has(selectedCategories[index].toString())) return true
        }
      })
    },
    isOnePage() {
      return this.rows <= this.perPage
    }
  },
  methods: {
    getSelectOptions() {
      this.categories.map(segment => {
        this.selectOptions.push({
          id: segment.id,
          title: null,
          group: segment.title
        });
        if(segment.children.length !== 0) {
          segment.children.map(category => {
            this.selectOptions.push({
              id: category.id,
              title: category.title,
              categories: category.children,
            });
          })
        }
      });


      /* show all option */
      if ( this.$refs.categorySelect?.placeholder )
      {
        // get Ids of all categories
        const allCategoriesIds = this.categories.map(category => category.id);

        // get placeholder from ref select
        const placeholder = this.$refs.categorySelect.placeholder;

        // fill clear option, append it as first element and select by default (id 0 is what makes it show all categories)
        const clearOption = {
          categories: allCategoriesIds,
          id: 0,
          title: placeholder
        };

        this.selectOptions.unshift(clearOption);

        const defaultCategorySelected = parseInt(window.utils.getQueryStringParameter('newsCategory')) > 0; 
        if ( ! defaultCategorySelected )
        {
          this.selectedCategory = clearOption;
        }
      }
      /* ___ show all option ___ */
    },
    getPostLink(postCategories) {
      let link = postCategories[categoryId];
      if (this.selectedCategory && this.selectedCategory.id) {
        const categories = new Set(this.selectedCategory.categories);
        for (let key in postCategories) {
          if (categories.has(parseInt(key))) {
            return postCategories[key]
          }
        }
      }
      return link
    },
    scrollTo(target, duration) {
      // if not scrolling already
      if ( !this.scrollerIsScrolling )
      {
        // scroll to target with desired duration
        VueScrollTo.scrollTo(target, {
          duration: duration,
          onStart: () => {
            // set scrolling variable
            this.scrollerIsScrolling = true;
          },
          onDone: () => {
            // unset scrolling variable
            this.scrollerIsScrolling = false;
          }
        });
      }
    }
  },
  watch: {
    perPage: function() {
      this.scrollTo('body', 500);
    },
    currentPage: function(newValue, oldValue) {
      this.scrollTo('body', 500);

      // change query string after changing pagination
      if ( newValue != oldValue )
      {
        window.utils.setQueryStringParameter('newsPage', this.currentPage);
      }
    },
    selectedCategory: function (newValue, oldValue) {

      if ( oldValue !== null && ( oldValue.id != newValue.id ) ) {
        this.currentPage = 1;
      }

      if ( newValue.id )
      {
        window.utils.setQueryStringParameter('newsCategory', newValue.id);
      }
      else
      {
        window.utils.setQueryStringParameter('newsCategory', 0);
      }
      
    }
  }
}

export default newsListConfig